module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "foreword"
    }
  }, [_c('h1', [_vm._v("Foreword")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_c('em', [_vm._v("Our life is twofold; Sleep hath its own world,")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_c('em', [_vm._v("A boundary between the things misnamed.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_c('em', [_vm._v("Death and existence")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Lord Byron")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_c('em', [_vm._v("The Dream")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2511b7ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0